// extracted by mini-css-extract-plugin
module.exports = {"titulo":"LandingPage_titulo__DcwVt","boton":"LandingPage_boton__3FWAP"};